import { capitalize } from 'lodash';
import { Search } from 'lucide-react';
import { DefaultSheet, DefaultTooltip, Col, Row, FormGroup, Label, SheetBody } from 'twyne-new.ui'

import { formatDate } from 'utils';

export default function DetailsModal({ children, data, title }) {
  return <DefaultSheet
    trigger={<DefaultTooltip content='Details' side='left'> <Search size={16} /> </DefaultTooltip>}
    title={title}
  >
    <SheetBody>
      <Row>
        {data ? data.map(([key, value], index) => <DetailsModalItem key={index} label={key} value={value} />) : children}
      </Row>
    </SheetBody>
  </DefaultSheet>
}

export function DetailsModalItem({ label, value }) {
  if (['created_at', 'updated_at'].includes(label)) {
    value = formatDate(value)
  }

  return <Col size='6'>
    <FormGroup>
      <Label>{capitalize(label)}</Label>
      <span className='twy-text-base-accent'>{value === true || value === false ? `${value}` : value || '--'}</span>
    </FormGroup>
  </Col>
}
